import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';

import { ChevronLeft, ChevronRight } from 'lucide-react';

import { Button } from '@codes/ui-kit';

(pdfjs as any).GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export const PdfViewContent = ({ url }: { url: string | undefined }) => {
    const [numPages, setNumPages] = useState<number>();
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [haveError, setHaveError] = useState(false);
    const [haveLoaded, setHaveLoaded] = useState(false);

    const isFirstPage = pageNumber === 1;
    const isLastPage = pageNumber === numPages;

    const onDocumentLoadSuccess = ({ numPages }: { numPages: number }): void => {
        setHaveLoaded(true);
        setNumPages(numPages);
    };

    const onDocumentLoadError = () => {
        setHaveError(true);
    };

    const pageMoveBtnTapped = (next: boolean) => {
        setPageNumber(prev => (next ? prev + 1 : prev - 1));
    };

    const retryButtonTapped = () => {
        setHaveError(false);
    };

    if (!url) {
        return <div className="min-h-[300px] flex items-center justify-center">URL이 제공되지 않았습니다.</div>;
    }

    if (haveError) {
        return (
            <div className="min-h-[300px] flex items-center justify-center gap-y-4 flex-col">
                pdf 파일을 로드하는데 실패했습니다.
                <Button onClick={retryButtonTapped}>Retry</Button>
            </div>
        );
    }

    return (
        <div className="relative flex justify-center items-center min-h-[300px]">
            <Document file={`${url}`} onLoadSuccess={onDocumentLoadSuccess} onLoadError={onDocumentLoadError}>
                <Page pageNumber={pageNumber} />
            </Document>
            {haveLoaded && (
                <div className="flex items-center justify-center gap-x-2 absolute  left-0 bottom-4 text-black h-10 w-full z-50">
                    <div className="px-2 h-full border bg-white flex gap-x-2 items-center border-black rounded">
                        {!isFirstPage && (
                            <button data-testid="prev-button" onClick={() => pageMoveBtnTapped(false)}>
                                <ChevronLeft />
                            </button>
                        )}

                        <div className="font-bold mx-2">{pageNumber}</div>
                        {!isLastPage && (
                            <button data-testid="next-button" onClick={() => pageMoveBtnTapped(true)}>
                                <ChevronRight />
                            </button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
